import { render, staticRenderFns } from "./Work_from_office.vue?vue&type=template&id=6a1e5dfb&"
import script from "./Work_from_office.vue?vue&type=script&lang=js&"
export * from "./Work_from_office.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports